import React from 'react';
import YearSelector from '../../common/YearSelector';

/**
 * Paso 1 del wizard: seleccionar el año tributario. Es el primer dato que
 * se pide — todo lo demás (gate de DJJ, régimen, módulo) depende de él,
 * porque cada año puede tener su propia ley, regímenes y forma de cálculo.
 */
const AnioStep = ({ selectedYear, onYearChange, yearOptions, onContinuar }) => (
  <div className="wizard-anio-container">
    <YearSelector
      selectedYear={selectedYear}
      onYearChange={onYearChange}
      yearOptions={yearOptions}
      label="Año Tributario"
    />
    <p>
      Selecciona el año tributario de la renta que quieres declarar o revisar.
      El formulario, los regímenes disponibles y la forma de cálculo pueden
      variar de un año a otro.
    </p>
    <button className="wizard-btn-continuar" onClick={onContinuar}>
      Continuar
    </button>
  </div>
);

export default AnioStep;
